import "moment/locale/pt-br";

import ModalComponent from "../../../Components/Modais";
import { TModoGestaoAtendimento } from "../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";
import { ACESSOS } from "../../../Routes/Acessos";
import Table from "../../../Components/Table";
import { ListarAtendimentosVistoriasTransferirController } from "../../../Controllers/VistoriaEntregaChaves/ListarAtendimentosVistorias/ListarAtendimentosVistoriasControllers";
import { FiltroAtendimentoVistoria } from "./FiltroAtendimentoVistoria";
import { ExportarExcelAtendimentosVistoriaController } from "../../../Controllers/Vistorias/GestaoDeVistorias/GestaoDeVistoriasControllers";
import ExportExcel from "../../../Components/StickyToolbar/ExportExcel";
import TransferirTodosAtendimento from "../../../Components/CardsPages/Atendimento/TransferirTodosAtendimentos";
import { IPropsTableChange } from "../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import useAtendimentoVistoria from "./useAtendimentoVistoria";

interface IAtendimentosVistoriaEntregaProps {
    atendimento: TModoGestaoAtendimento;
}

export default function AtendimentoVistoriaEntregaChaves(
    props: IAtendimentosVistoriaEntregaProps
) {
    const {
        PageFilter,
        filter,
        setPageFilter,
        setPage,
        setFilter,
        idEmpreendimentoOption,
        setIdEmpreendimentoOption,
        valueEtapa,
        setValueEtapa,
        idTipoPeso,
        setIdTipoPeso,
        atendimentosVistoria,
        atendimentosVistoriaLoading,
        updateAtendimentos,
        show,
        setShow,
        modal,
        totalPaginas,
        pesquisaText,
        setPesquisaText,
        handleSearch,
        tableviewColumns,
        filterStorage,
    } = useAtendimentoVistoria(props.atendimento);

    return (
        <>
            <Table
                columns={tableviewColumns}
                data={atendimentosVistoria?.ATENDIMENTOS_VISTORIA ?? []}
                keyField="ID_CASO"
                onTableChange={(_type, newState) => {
                    const state = newState as IPropsTableChange;

                    if (state.searchText !== "") {
                        handleSearch(
                            state.searchText,
                            state
                            // naoContem
                        );
                        setPesquisaText(state.searchText);
                    } else if (pesquisaText.length > 0) {
                        setFilter({
                            PESQUISA: state.searchText,
                        });
                    } else {
                        setPage(state.page);
                    }
                }}
                defaultStyle={{
                    align: "center",
                    classes: "p-2",
                }}
                loading={atendimentosVistoriaLoading}
                tableView={{
                    columns: tableviewColumns,
                    noSort: true,
                    sizePerPage: 10,
                    cancelYScroll: true,
                    defaultStyle: true,
                }}
                remote={{ pagination: true }}
                totalPages={totalPaginas}
                noDataIndication={() => (
                    <div className="text-black-50 text-center">
                        Nenhum Atendimento encontrado
                    </div>
                )}
                noHover
                bordered={false}
            />
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
            <FiltroAtendimentoVistoria
                handleSubmit={(formData) => {
                    setPageFilter({
                        filter: {
                            ...formData,
                            ID_EMPREENDIMENTO: idEmpreendimentoOption?.map(
                                (e) => e.value
                            ),
                            ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO:
                                valueEtapa?.map((e) => e.value),
                            ID_TIPOS_PESOS_ATENDIMENTOS: idTipoPeso,
                            // FL_CONTEM: naoContem,
                        },
                        page: 1,
                    });
                }}
                storageManager={filterStorage}
                defaultFilter={filter}
                setIdEmpreendimentoOption={setIdEmpreendimentoOption}
                setValueEtapa={setValueEtapa}
                setIdTipoPeso={setIdTipoPeso}
                idTipoPeso={idTipoPeso}
                atendimento={props.atendimento}
            // setNaoContem={setNaoContem}
            />

            <TransferirTodosAtendimento
                ID_TIPO_CASO={ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO}
                filter={filter}
                setShow={setShow}
                update={() => {
                    updateAtendimentos();
                }}
                controller={() =>
                    ListarAtendimentosVistoriasTransferirController(
                        props.atendimento,
                        {
                            ...PageFilter.filter,
                            ID_CASO:
                                PageFilter.filter?.ID_CASO?.toString() === ""
                                    ? 0
                                    : PageFilter.filter?.ID_CASO,

                            ID_USUARIO:
                                PageFilter.filter?.ID_USUARIO?.toString() === ""
                                    ? 0
                                    : PageFilter.filter?.ID_USUARIO,
                        }
                    )
                }
            />

            <ExportExcel
                baixarExcelController={async () =>
                    ExportarExcelAtendimentosVistoriaController(
                        props.atendimento,
                        {
                            ...PageFilter.filter,
                            ID_USUARIO:
                                PageFilter.filter?.ID_USUARIO?.toString() === ""
                                    ? 0
                                    : PageFilter.filter?.ID_USUARIO,
                            ID_TIPO_CANAL_ATENDIMENTO:
                                PageFilter.filter?.ID_TIPO_CANAL_ATENDIMENTO?.toString() ===
                                    ""
                                    ? 0
                                    : PageFilter.filter?.ID_TIPO_CANAL_ATENDIMENTO,
                            ID_CASO:
                                PageFilter.filter?.ID_CASO?.toString() === ""
                                    ? 0
                                    : PageFilter.filter?.ID_CASO,
                        }
                    )
                }
                nomeArquivo={"Atendimentos_Vistoria"}
            />
        </>
    );
}
